import './Dropdown.scss'

import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'

import classNames from 'classnames'

const Dropdown = ({ button, basic, open, grow, scroll, disabled, children }) => {
  const [isOpen, setIsOpen] = useState()
  const dropdownRef = useRef()
  const buttonRef = useRef()
  const modalRef = useRef()
  const controlled = open !== undefined

  const handleClick = useCallback(() => !controlled && !disabled && setIsOpen(!isOpen), [setIsOpen, isOpen, controlled, disabled])

  const handleBlur = useCallback(event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsOpen(false)
    }
  }, [setIsOpen])

  const handleFocus = useCallback(() => {
    if (controlled) setIsOpen(open)
  }, [controlled, open])

  useLayoutEffect(() => {
    const rect = modalRef.current.getBoundingClientRect()
    const buttonRect = buttonRef.current.getBoundingClientRect()
    const needsToGrow = grow && (rect.width < buttonRect.width)
    const rectWidth = needsToGrow ? buttonRect.width : rect.width
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth)
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight)
    if (buttonRect.bottom + rect.height <= windowHeight || scroll) {
      if (buttonRect.left + rectWidth <= windowWidth) {
        // Open to the right-bottom
        modalRef.current.style.left = "0px"
        modalRef.current.style.top = buttonRect.height + "px"
      } else {
        // Open to the left-bottom
        modalRef.current.style.left = (buttonRect.width - rectWidth) + "px"
        modalRef.current.style.top = buttonRect.height + "px"
      }
      if (scroll) {
        modalRef.current.style.maxHeight = (windowHeight - buttonRect.bottom) + "px"
        modalRef.current.style.overflowY = "scroll"
      }
    } else {
      if (buttonRect.left + rectWidth <= windowWidth) {
        // Open to the right-up
        modalRef.current.style.left = "0px"
        modalRef.current.style.top = -rect.height + "px"
      } else {
        // Open to the left-up
        modalRef.current.style.left = (buttonRect.width - rectWidth) + "px"
        modalRef.current.style.top = -rect.height + "px"
      }
    }
    if (needsToGrow) modalRef.current.style.width = rectWidth + "px"
  }, [isOpen, grow, scroll])

  useLayoutEffect(() => {
    if (isOpen && !controlled) {
      modalRef.current.children[0].focus()
    }
  }, [isOpen, controlled])

  useLayoutEffect(() => {
    const eventListener = () => setIsOpen(false)
    const element = dropdownRef.current
    element.addEventListener('DropdownCloseEvent', eventListener, false)
    return () => {
      element.removeEventListener('DropdownCloseEvent', eventListener, false)
    }
  }, [])

  useEffect(() => setIsOpen(open), [open])

  return (
    <div ref={dropdownRef} className="dropdown" onBlur={handleBlur} onFocus={handleFocus}>
      <div ref={buttonRef} className="-button" onClick={handleClick}>
        {button}
      </div>
      <div ref={modalRef} className={classNames("-modal", { "-visible": isOpen, "-basic": basic })}>
        <div className="-focus" tabIndex="0">
          {children}
        </div>
      </div>
    </div>
  )
}

const closeDropdownEvent = () => {
  return new CustomEvent('DropdownCloseEvent', {
    bubbles: true,
    cancelable: true
  })
}

export default Dropdown
export { closeDropdownEvent }